module.exports = __webpack_public_path__ + "static/IMG_5861-ba2f9710b704ba4e60801846c9c36538.jpg";